/**
 * Placeholder shown in the original tab AFTER the test has been launched
 * in a separate window. Keeps the student from accidentally re-navigating
 * to the login page or trying to start a second concurrent session.
 */
import { Card } from "@/components/ui/card";
import { ShieldAlert, ExternalLink } from "lucide-react";

export default function TestWindowOpen() {
    return (
        <div className="min-h-[80vh] bg-[#0A2818] flex items-center justify-center px-6 py-16" data-testid="accuplacer-window-open">
            <Card className="max-w-md w-full p-8 bg-[#134B30] text-white border-[#C79520]/30 text-center">
                <div className="text-[10px] uppercase tracking-[0.3em] text-[#C79520] mb-3 flex items-center justify-center gap-2">
                    <ShieldAlert className="h-3.5 w-3.5" />
                    Proctored HCC English Test
                </div>
                <ExternalLink className="h-10 w-10 text-[#C79520] mx-auto mb-3" />
                <h1 className="font-display text-2xl mb-2">Your test is open in a new window.</h1>
                <p className="text-sm text-white/75 leading-relaxed">
                    Please switch back to the HCC English Test window to continue. Do not
                    close that window until you have submitted your test.
                </p>
                <p className="text-xs text-white/55 mt-6">
                    Closing the test window will count as a violation and may invalidate
                    your attempt.
                </p>
            </Card>
        </div>
    );
}
